export default {
  methods: {
    camelCaseToSentence: str => {
      const formattedCamelCase = str.replace(/([A-Z])/g, ' $1')
      return formattedCamelCase.charAt(0).toUpperCase() + formattedCamelCase.slice(1)
    },

  },
}
